<span class="anc-status-badge" [ngClass]="'anc-status-badge--' + tone()">
    <span *ngIf="dot()" class="anc-status-badge__dot"></span>
    <ng-content></ng-content>
</span>
